import { type SessionState, sessionStateSchema, type Viewer } from '@crm/contracts';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { request, setCsrfToken } from '@/shared/api';

export const sessionKey = ['session'] as const;

export async function fetchSession(signal?: AbortSignal): Promise<SessionState> {
  const state = await request('GET', '/session', {
    schema: sessionStateSchema,
    ...(signal ? { signal } : {}),
  });
  setCsrfToken(state.csrfToken);
  return state;
}

export const sessionQuery = queryOptions({
  queryKey: sessionKey,
  queryFn: ({ signal }) => fetchSession(signal),
  staleTime: 60_000,
});

/** Stores a session the BFF returned (sign in) and its CSRF token. */
export function sessionFromLogin(state: SessionState): SessionState {
  setCsrfToken(state.csrfToken);
  return state;
}

export function useViewer(): Viewer | null {
  const { data } = useQuery(sessionQuery);
  return data?.authenticated ? data.viewer : null;
}
